// D2 — Technician visit constants (mirror backend constants/visitStates.js).

export const VISIT_TYPE = { CORRECTIVE: "corrective", PREVENTIVE: "preventive", INSTALL: "install" };

export const VISIT_TYPE_LABEL = {
  corrective: "Corrective",
  preventive: "Preventive",
  install: "New Install",
};
export const VISIT_TYPE_TAG_COLOR = {
  corrective: "orange",
  preventive: "blue",
  install: "green",
};
export const VISIT_TYPE_OPTIONS = Object.values(VISIT_TYPE).map((v) => ({
  value: v,
  label: VISIT_TYPE_LABEL[v],
}));

export const VISIT_STATUS = {
  SCHEDULED: "scheduled",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};
export const VISIT_STATUS_LABEL = {
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};
export const VISIT_STATUS_TAG_COLOR = {
  scheduled: "default",
  in_progress: "processing",
  completed: "success",
  cancelled: "error",
};
export const VISIT_STATUS_OPTIONS = Object.values(VISIT_STATUS).map((v) => ({
  value: v,
  label: VISIT_STATUS_LABEL[v],
}));

export const CHECKLIST_ITEM_TYPE_OPTIONS = [
  { value: "boolean", label: "Yes / No" },
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "select", label: "Select" },
  { value: "photo", label: "Photo" },
];

// Transition buttons available for a given visit status.
export function availableVisitActions(status) {
  switch (status) {
    case VISIT_STATUS.SCHEDULED:
      return [
        { key: "start", label: "Start visit", type: "primary" },
        { key: "cancel", label: "Cancel", danger: true },
      ];
    case VISIT_STATUS.IN_PROGRESS:
      return [
        { key: "complete", label: "Complete visit", type: "primary" },
        { key: "cancel", label: "Cancel", danger: true },
      ];
    default:
      return [];
  }
}
